/**
 * Ledger device identity.
 *
 * One UUID per browser, persisted in localStorage. Generated lazily on first
 * access. This is how we key the contractor_profile — no account, no signup.
 * If the user clears storage, they'll get a new identity and onboard again.
 *
 * We prefer crypto.randomUUID() (available in modern iOS Safari / Android
 * Chrome) and fall back to a Math.random-based generator for extremely old
 * browsers rather than crashing.
 */
const STORAGE_KEY = "ledger.device_id";

function generateUuid() {
  try {
    if (typeof crypto !== "undefined" && crypto.randomUUID) {
      return crypto.randomUUID();
    }
  } catch (e) {
    /* fall through */
  }
  // RFC4122-ish fallback. Good enough for anonymous identity.
  return "xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx".replace(/[xy]/g, (c) => {
    const r = (Math.random() * 16) | 0;
    const v = c === "x" ? r : (r & 0x3) | 0x8;
    return v.toString(16);
  });
}

export function getDeviceId() {
  try {
    let id = localStorage.getItem(STORAGE_KEY);
    if (!id) {
      id = generateUuid();
      localStorage.setItem(STORAGE_KEY, id);
    }
    return id;
  } catch (e) {
    // Storage disabled (Safari private mode with cookies off, etc.) — return
    // an ephemeral id so the app still works. Profile won't persist.
    return generateUuid();
  }
}
